(function () {
    'use strict';

    angular
        .module('elogbooks.admin.permissions-overview')
        .controller('CommonPermissionsListController', CommonPermissionsListController);

    CommonPermissionsListController.$inject = ['frontendPaginationService', '$state', '$stateParams', 'config'];

    function CommonPermissionsListController(frontendPaginationService, $state, $stateParams, config) {
        var vm = this;
        vm.permissionList = config.permissionService.getAllTranslatedOrdered();
        vm.stateParams = $stateParams;

        const permissionKey = config.entityPrefix + 'Permission';
        const descriptionKey = config.entityPrefix + 'Description';

        vm.criteria = {
            [permissionKey]: {
                title: 'PERMISSION',
                type: 'text',
                value: $stateParams[permissionKey] || null
            },
            [descriptionKey]: {
                title: 'DESCRIPTION',
                type: 'text',
                value: $stateParams[descriptionKey] || null
            }
        };

        const applyFilter = () => {
            const perm = (vm.criteria[permissionKey].value || '').toString().toLowerCase();
            const desc = (vm.criteria[descriptionKey].value || '').toString().toLowerCase();

            let filtered = vm.permissionList;
            if (perm) {
                filtered = filtered.filter(p => (p.translation || '').toLowerCase().indexOf(perm) !== -1);
            }
            if (desc) {
                filtered = filtered.filter(p => (p.description || '').toLowerCase().indexOf(desc) !== -1);
            }

            vm.permissionListFiltered = filtered;
            vm.permissionListPaginated = frontendPaginationService.getAllPaginated(
                vm.permissionListFiltered,
                +($stateParams[config.entityPrefix + 'Page'] || 1),
                +($stateParams[config.entityPrefix + 'Limit'] || 30)
            );
        };

        vm.search = function() {
            const override = {};
            override[config.entityPrefix + 'Page'] = 1;
            override[permissionKey] = vm.criteria[permissionKey].value || null;
            override[descriptionKey] = vm.criteria[descriptionKey].value || null;

            $state.go('.', angular.extend({}, $stateParams, override), { reload: false }).then(applyFilter);
        };

        vm.clear = function() {
            vm.criteria[permissionKey].value = null;
            vm.criteria[descriptionKey].value = null;
            vm.search();
        };

        applyFilter();

        vm.entityName = config.entityName;
        vm.prefix = config.entityPrefix;
        vm.viewUsersAvailable = config.viewUsersAvailable;
    }
})();
